<h1 class="ap-blue">{{'ml_151081' | translate}}</h1>

<div class="mt-3 mb-3">
  <app-excel-import-button [isProcessing$]="importing$" [onFileImport]="onFileSelected"></app-excel-import-button>
</div>

<div class="mb-3">
  <app-message-data [errorMsg$]="importErrorMessage$" [infoMsg$]="importProgressMessage$"></app-message-data>
</div>
